export class ApiKeyData {
    IsConfigured: boolean;
    ExpirationDate: Date;
    BlobsLifeTime: string;
    Enabled: boolean;
}

export interface IApiKeyResponse {
    ApiKey: string;
}

export class CurrentEnvironmentResponse {
    Current: string;
}
